export let env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

if ( window.location.origin.indexOf( '://localhost' ) >= 0 ) {
    env = 'qa';
}

const envPrefix = env ? `${ env }.` : '';

export default {
    env,
    envPrefix,
    EXPERIENCE_REGISTRY_API_URL: `https://${ envPrefix }api.biw.cloud/experienceregistryapi/services/v1`,
    AUTHORITY: `https://${ envPrefix }api.biw.cloud/v1/id`,
    PRIVACY_API_URL: `https://${ envPrefix }api.biw.cloud/privacyapi/services/v1`,
    PRIVACY_DOWNLOAD_API_URL: `https://${ envPrefix }api.biw.cloud/privacyapi`,
    SOLUTIONS_API_URL: `https://${ envPrefix }api.biw.cloud/solutionapi/services/v1`,
    CMX_API_URL: `https://${ envPrefix }api.biw.cloud/v2/cmx`,
    COMPANY_SETUP_URL: `https://${ envPrefix }api.biw.cloud/v1/company-setup`
};
